/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GpsValidFix
 */
export interface GpsValidFix {
    [key: string]: any | any;
    /**
     * 
     */
    lat: number;
    /**
     * 
     */
    lon: number;
}

/**
 * Check if a given object implements the GpsValidFix interface.
 */
export function instanceOfGpsValidFix(value: object): value is GpsValidFix {
    if (!('lat' in value) || value['lat'] === undefined) return false;
    if (!('lon' in value) || value['lon'] === undefined) return false;
    return true;
}

export function GpsValidFixFromJSON(json: any): GpsValidFix {
    return GpsValidFixFromJSONTyped(json, false);
}

export function GpsValidFixFromJSONTyped(json: any, ignoreDiscriminator: boolean): GpsValidFix {
    if (json == null) {
        return json;
    }
    return {
        
            ...json,
        'lat': json['lat'],
        'lon': json['lon'],
    };
}

export function GpsValidFixToJSON(json: any): GpsValidFix {
    return GpsValidFixToJSONTyped(json, false);
}

export function GpsValidFixToJSONTyped(value?: GpsValidFix | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
            ...value,
        'lat': value['lat'],
        'lon': value['lon'],
    };
}

